(function(){
  'use strict';

  angular.module('eclipseApp.checkout').directive('validateSin', ['buyUtils', function(buyUtils){
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function(scope, elem, attr, ctrl){

        ctrl.$validators.format = function(modelVal, viewVal){

          return buyUtils.validateSin(modelVal);

        };

      }
    };
  }]);
})();
